import Repository from '../Repository';

const url = '/admin/series';

export default {
    getAllSeries(includeVideos = true) {
        return Repository.get(`${url}`,{
            params:{
                include_videos : includeVideos,
            }
        });
    },
    getSeries(slug) {
        return Repository.get(`${url}/${slug}`);
    },
    createSeries(payload) {
        return Repository.post(`${url}/`, payload);
    },
    updateSeries(slug, payload) {
        return Repository.post(`${url}/${slug}`, payload);
    },
    deleteSeries(slug) {
        return Repository.delete(`${url}/${slug}`);
    },

    removeVideo(slug, videoId) {
        return Repository.get(`${url}/${slug}/video/${videoId}/remove`);
    },
    addVideo(slug, videoId) {
        return Repository.get(`${url}/${slug}/video/${videoId}/add`);
    }

}
